module.exports = __webpack_public_path__ + "media/dashboard/assets/images/chat-f40075502011c8ef386741e33901a0a7.svg";